var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.917 6.975v6.209c0 .125-.042.25-.15.358l-4.592 4.625a.52.52 0 0 1-.392.167H6.142a4.06 4.06 0 0 1-4.059-4.059v-7.3a4.06 4.06 0 0 1 4.059-4.058h7.716a4.06 4.06 0 0 1 4.059 4.058",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.908 5.242a.624.624 0 0 1-.625-.625V2.292a.624.624 0 1 1 1.25 0v2.317c0 .35-.275.633-.625.633M13.092 5.242a.624.624 0 0 1-.625-.625V2.292a.624.624 0 1 1 1.25 0v2.317c0 .35-.275.633-.625.633M12.317 10.592H6.133a.624.624 0 1 1 0-1.25h6.184a.624.624 0 1 1 0 1.25M10 13.684H6.133a.624.624 0 1 1 0-1.25H10a.624.624 0 1 1 0 1.25M17.917 13.183c0 .125-.042.25-.15.358l-4.592 4.625a.52.52 0 0 1-.392.167.54.54 0 0 1-.541-.534v-2.916c0-1.217 1.033-2.225 2.3-2.225.791-.009 1.891-.009 2.833-.009.325 0 .542.259.542.534"
  })));
};
export default SvgNote;